import * as React from "react";
import { TagInput } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const SUGGESTIONS = ["creators", "educators", "founders", "developers", "designers", "marketers"];

export function TagInputDemo() {
  const [tags, setTags] = React.useState<string[]>(["creators"]);
  const [empty, setEmpty] = React.useState<string[]>([]);

  return (
    <Section
      id="tag-input"
      title="TagInput"
      description="Controlled multi-tag field with keyboard-navigable suggestions. Enter adds, Backspace pops, Arrow keys + Enter pick a suggestion. Tokenised input chrome; <Label> primitive."
    >
      <VariantBlock label="With suggestions">
        <div className="w-80">
          <TagInput
            label="Audience tags"
            value={tags}
            onChange={setTags}
            suggestions={SUGGESTIONS}
            placeholder="Add an audience"
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Empty + no suggestions">
        <div className="w-80">
          <TagInput label="Keywords" value={empty} onChange={setEmpty} />
        </div>
      </VariantBlock>

      <VariantBlock label="Disabled">
        <div className="w-80">
          <TagInput
            label="Locked"
            value={["fixed", "readonly"]}
            onChange={() => {}}
            disabled
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
